// extracted by mini-css-extract-plugin
export default {"homeContent":"styles_homeContent__4X4Ys","homeContent__container":"styles_homeContent__container__Iwf6s"};